import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiResponse, SiteFreightTypes } from 'app/shared/types';
import { environment } from 'environment/environment';
import { BaseApiService } from './base-api.service';
import { CONTROLLERS } from './controllers';
import { SITE_ID } from './tokens/tokens.const';

@Injectable({
  providedIn: 'root',
})
export class FreightTypesService extends BaseApiService<
  ApiResponse<{ freightTypes: SiteFreightTypes[] }>,
  ApiResponse<{ freightType: SiteFreightTypes }>,
  ApiResponse<{ id: string }>
> {
  constructor(
    public override http: HttpClient,
    @Inject(SITE_ID) private siteId: string
  ) {
    super(http, environment.siteManagementApiBaseUrl);
  }

  public override controllerName(): string {
    if (!this.siteId) {
      throw new Error('Site ID is not set.');
    }

    return `${CONTROLLERS.sites}/${this.siteId}/freight-types`;
  }
}
